module.exports = __webpack_public_path__ + "media/images/front/dplus_banner_movie_250101-f556fe10abfa0abad3a57c7814f7e7f5.jpg";